<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content link-order-item-to-batch-dialog__content">
  <p class="link-order-item-to-batch-dialog__message">{{ data.message }}</p>

  <mat-form-field appearance="outline" class="link-order-item-to-batch-dialog__field">
    <mat-label>Search for a batch</mat-label>
    <input
      required
      type="text"
      placeholder="Search for batches"
      aria-label="Search for a batch"
      matInput
      [formControl]="batchNumber"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      data-testid="add-medicine-autocompletion-list"
      (optionSelected)="batchSelected($event)"
      autoActiveFirstOption
      #auto="matAutocomplete"
    >
      @for (batch of batches; track batch) {
        <mat-option [value]="batch">
          {{ batch.batch_number }} - {{ batch.medicine_dosage_type.medicine.name }}
        </mat-option>
      }
    </mat-autocomplete>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button
    type="button"
    [disabled]="!selectedBatch"
    mat-flat-button
    (click)="linkToBatch()"
    color="primary"
    cdkFocusInitial
  >
    Link
  </button>
</div>
